import { BASE_API_URL } from "../../config/Api";
import { ADD_ALERT, ENABLE_DISABLE_ALERT, GET_ALERT, GET_ALERT_LIST, ALERT_COMPLETED, GET_ALERT_TRANSACTION } from "./ActionType";

export const getAlert = (alertId, token) => async (dispatch) => {
    try {
      const res = await fetch(
        `${BASE_API_URL}/getAlert/${alertId}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const resData = await res.json();
      dispatch({ type: GET_ALERT, payload: resData });
    } catch (error) {}
  };

  export const getAlerts = (loginId, token) => async (dispatch) => {
    try {
      const res = await fetch(
        `${BASE_API_URL}/getAlertList/${loginId}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const resData = await res.json();
      dispatch({ type: GET_ALERT_LIST, payload: resData });
    } catch (error) {}
  };

  export const addAlert=(formData,token)=>async(dispatch)=>{
      try {
          const res=await fetch(`${BASE_API_URL}/createAlert`,{
              method: "POST",
              headers: {
                  "Content-Type": "application/json",
                  Authorization: `Bearer ${token}`
              },
              body: JSON.stringify(formData),
          })
          const resData=await res.json();
          if (res.ok) {
              dispatch({ type: ADD_ALERT, payload: resData });
              return { success: true };
          } else {
              throw { success: false, error: resData.message || 'An unknown error occurred' };
          }
      } catch (error) {
           console.error("Error:", error);
      }
      
  }
export const enableDisableAlert = (alertId,status, token) => async (dispatch) => {
    try {
      const res = await fetch(
        `${BASE_API_URL}/disableAndEnableAlert?alertId=${alertId}&status=${status}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const resData = await res.json();
    
    
        if (res.ok) {
      dispatch({ type: ENABLE_DISABLE_ALERT, payload: resData });
              return { success: true };
          } else {
              throw { success: false, error: resData.message || 'An unknown error occurred' };
          }
    
    
    } catch (error) {}
  };

  export const alertCompleted=(token, alertId)=>async(dispatch)=>{
      try {
          const res=await fetch(`${BASE_API_URL}/alertCompleted?alertId=${alertId}`,{
              method: "PUT",
              headers: {
                  "Content-Type": "application/json",
                  Authorization: `Bearer ${token}`
              }
          })
          const resData=await res.json();
          if (res.ok) {
              dispatch({ type: ALERT_COMPLETED, payload: resData });
              return resData;
          } else {
              throw new Error(resData.statusDesc || 'Unknown error occurred');
          }
      } catch (error) {
           console.error("Error:", error);
      }
  }

  export const getAlertTransaction = (alertId, year,  token) => async (dispatch) => {
    try {
      const res = await fetch(
        `${BASE_API_URL}/getAlertTransation?alertId=${alertId}&year=${year}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const resData = await res.json();
      dispatch({ type: GET_ALERT_TRANSACTION, payload: resData });
    } catch (error) {}
  };
  
  